import { takeLatest, call, put, all } from 'redux-saga/effects';
import axios from 'axios';
import axiosRetry from 'axios-retry';

import { fetchRequestSuccess, fetchRequestFailure } from './request.actions';
import { RequestActionTypes, FetchRequestStart } from './request.types';
import { Message } from '../models/message.model';

axiosRetry(axios, { 
    retries: 2,
    retryDelay: axiosRetry.exponentialDelay,
    retryCondition: (error) => {
        console.log(error.response?.status);
        return error.response?.status !== 504;
    }
});

const getMessage = async (messageId: string, programmatic: boolean | undefined) => {
    const response = await axios.get<Message>(`${process.env.REACT_APP_DEACTIVATOR_API}/deactivator/v1/message/${messageId}?programmatic=${programmatic}`);
    return response.data;
};

export function* fetchRequestSagaAsync(action: FetchRequestStart) {
    try {
        const data: Message = yield getMessage(action.payload.messageId, action.payload.programmatic);
        yield put(
            fetchRequestSuccess({
                message: data
            })
        );
    } catch (error: any) {
        yield put(
            fetchRequestFailure({
                errorMessage: error.message
            })
        );
    };
};

export function* fetchRequestSaga() {
    yield takeLatest(RequestActionTypes.FETCH_REQUEST_START, fetchRequestSagaAsync)
};

export function* requestSagas() {
    yield all([
        call(fetchRequestSaga),
    ]);
};
